import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Box, 
  useTheme,
} from '@mui/material';

import { usePagination } from '@frontend/features/common/components/Table';
import { ListLayout } from '@frontend/features/common/components/ListLayout';
import { ListContentLayout } from '@frontend/features/common/components/ListContentLayout';
import {
  useGetHotelBoards,
} from '@frontend/features/hotel-content-manager/queries';
import { MultiLanguageText } from '@bandido/shared/interfaces';
import { InfoLanguage, OrderOptionsValues } from '@bandido/shared/enums';

export const BoardsView = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const pagination = usePagination();
  const [searchText, setSearchText] = useState('');
  const { data: boards, isLoading: isLoadingBoards } = useGetHotelBoards({
    searchText,
    currentPage: pagination.page,
    pageSize: pagination.rowsPerPage,
    sort: 'id',
    order: OrderOptionsValues.asc
  });

  return (
    <>
      <ListLayout 
        title={t('hotelContent.management.boards.title') || 'Boards'} 
        subtitle={t('hotelContent.management.boards.subtitle') || 'Manage and view boards'}
      >
        <ListContentLayout
          pagination={pagination}
          stickyHeader
          onSearchChange={(value: string) => {
            setSearchText(value);
          }}
          columns={[
            {
              id: 'code',
              label: t('hotelContent.management.boards.table.code'),
              align: 'left',
              maxWidth: 100
            },
            {
              id: 'supplierName',
              label: t('hotelContent.management.boards.table.supplierName'),
              align: 'left',
              minWidth: 100,
            },
            {
              id: 'texts',
              label: t('hotelContent.management.boards.table.texts'),
              align: 'left',
              format: (texts: MultiLanguageText) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                  <Box sx={{ fontSize: '0.875rem' }}>
                    {`${InfoLanguage.English}: ${texts[InfoLanguage.English] || t('common.notValueFound')}`}
                  </Box>
                  <Box sx={{ fontSize: '0.75rem', color: theme.palette.text.secondary }}>
                    {`${InfoLanguage.Spanish}: ${texts[InfoLanguage.Spanish] || t('common.notValueFound')}`}
                  </Box>
                  <Box sx={{ fontSize: '0.75rem', color: theme.palette.text.secondary }}>
                    {`${InfoLanguage.Portuguese}: ${texts[InfoLanguage.Portuguese] || t('common.notValueFound')}`}
                  </Box>
                </Box>
              ),
            }
          ]}
          isLoading={isLoadingBoards}
          data={{
            key: 'id',
            items: boards?.items || [],
            totalCount: boards?.count || 0,
          }}
        />
      </ListLayout>
    </>
  );
};
